import PropTypes from 'prop-types';
import React from 'react';

import {CloudFunctionsClient} from '../../CloudFunctionsClient';
import {Input} from '../../components/Input';
import {getCurrentUserId} from '../../firebase';
import {saveStreetTeamOnboardingStep} from '../OnboardingSteps';

class TermsAndConditionsStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cellPhone: '',
      zipCode: '',
    };
  }

  submitTermsAndConditions = async(e) => {
    e.preventDefault();

    const userId = getCurrentUserId();

    const {cellPhone, zipCode} = this.state;

    await CloudFunctionsClient.post('/userApi-signRangerTos', {cellPhone, zipCode});

    // TODO: save IP address
    saveStreetTeamOnboardingStep('Terms and Conditions', {
      cellPhone,
      zipCode,
      termsAndConditionsVersion: '2018-06-29',
    });

    const {onStepComplete} = this.props;
    onStepComplete();
  }

  render() {
    const {zipCode, cellPhone} = this.state;

    return (
      <div>
        <h2>
          Join Ranger Team
        </h2>

        <p>
          To join the Ranger Team, please provide your zip code and
          mobile phone number, and agree to the terms and conditions in the Charger Agreement.
        </p>

        <form onSubmit={this.submitTermsAndConditions}>
          <div className="row my-2">
            <Input
              display='Zip Code'
              required={true}
              updateValue={(zipCode) => this.setState({zipCode})}
              value={zipCode}
              type="tel"
            />
          </div>

          <div className="row my-2">
            <Input
              display='Cell Phone'
              required={true}
              updateValue={(cellPhone) => this.setState({cellPhone})}
              value={cellPhone}
              type="tel"
            />
          </div>

          <button className="btn btn-primary" type='submit'>
            Agree
          </button>
        </form>

        <p className='small mt-2'>
          By clicking "Agree" you agree to the terms and conditions in the <a
            href="https://skipscooters.com/chargeragreement/"
            target="_blank"
            rel="noopener noreferrer"
          >Charger Agreement</a>.
        </p>
      </div>
    )
  }
}

TermsAndConditionsStep.propTypes = {
  onStepComplete: PropTypes.func.isRequired
}

export {TermsAndConditionsStep};



// WEBPACK FOOTER //
// ./src/street-team/onboarding/TermsAndConditionsStep.js